export const HeaderHeight = {
  data() {
    return {
      headerHeight: 50,
      headerResizeObserver: null,
      headerMutationObserver: null,
      observedHeaderElements: null,
      pendingAnimationId: null,
    };
  },
  methods: {
    scheduleHeaderUpdate() {
      if (this.pendingAnimationId === null) {
        this.pendingAnimationId = requestAnimationFrame(() => {
          this.pendingAnimationId = null;
          this.observeHeaders();
        });
      }
    },
    handleHostMutations(mutations = []) {
      if (!this.$el || mutations.length === 0) {
        this.scheduleHeaderUpdate();
        return;
      }
      const root = this.getFallbackRoot();
      const hasExternalMutation = mutations.some(
        (mutation) =>
          mutation.target === root || !this.$el.contains(mutation.target)
      );
      if (hasExternalMutation) {
        this.scheduleHeaderUpdate();
      }
    },
    handleTransitionEnd(event) {
      const root = this.getFallbackRoot();
      if (
        this.$el &&
        event.target !== root &&
        this.$el.contains(event.target)
      ) {
        return;
      }
      this.scheduleHeaderUpdate();
    },
    getHeaderElements() {
      return Array.from(
        document.querySelectorAll(
          'header.GatewayMenuHeader, header.cxc-header, main nav[class*="fpg-web--Submenu-module"], #global-topbar nav, header[class*="fpg-web--AuthHeader-module--auth-header"], header[class*="fpg-web--StandardHeader-module--header"]'
        )
      );
    },
    getFallbackRoot() {
      if (this.$el && typeof this.$el.closest === 'function') {
        return this.$el.closest('.marketplace-root');
      }
      return null;
    },
    setHeaderHeight() {
      const elements = this.getHeaderElements();
      if (elements.length > 0) {
        this.headerHeight = elements
          .map((el) => el.offsetHeight)
          .reduce(
            (previousValue, currentValue) => previousValue + currentValue,
            0
          );
        return;
      }

      const root = this.getFallbackRoot();
      if (root) {
        const offset =
          root.getBoundingClientRect().top +
          (window.pageYOffset || window.scrollY || 0);
        if (offset >= 0) {
          this.headerHeight = offset;
          return;
        }
      }

      this.headerHeight = 50;
    },
    observeHeaders() {
      let elements = this.getHeaderElements();
      if (elements.length === 0) {
        const root = this.getFallbackRoot();
        if (root) {
          elements = [root];
        }
      }

      for (const element of this.observedHeaderElements) {
        if (!elements.includes(element)) {
          this.headerResizeObserver.unobserve(element);
          this.observedHeaderElements.delete(element);
        }
      }

      elements.forEach((element) => {
        if (!this.observedHeaderElements.has(element)) {
          this.headerResizeObserver.observe(element);
          this.observedHeaderElements.add(element);
        }
      });

      this.setHeaderHeight();
    },
  },
  mounted() {
    this.observeHeaders();
  },
  destroyed() {
    window.removeEventListener('resize', this.scheduleHeaderUpdate);
    document.removeEventListener(
      'transitionend',
      this.handleTransitionEnd,
      true
    );
    if (this.pendingAnimationId !== null) {
      cancelAnimationFrame(this.pendingAnimationId);
      this.pendingAnimationId = null;
    }
    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect();
      this.headerResizeObserver = null;
    }
    this.observedHeaderElements.clear();
    if (this.headerMutationObserver) {
      this.headerMutationObserver.disconnect();
      this.headerMutationObserver = null;
    }
  },
  created() {
    this.observedHeaderElements = new Set();
    this.headerResizeObserver = new ResizeObserver(this.setHeaderHeight);
    this.observeHeaders();
    this.headerMutationObserver = new MutationObserver(
      this.handleHostMutations
    );
    this.headerMutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
    window.addEventListener('resize', this.scheduleHeaderUpdate);
    document.addEventListener('transitionend', this.handleTransitionEnd, true);
  },
};
